<template>
    <div class="o-sorting-panel sorting-panel">
        <span 
            v-if="label"
            class="sorting-panel__label"
        >
            {{ label }}
        </span>
        <div class="sorting-panel__wrapper">
            <button
                type="button"
                class="sorting-panel__button"
                :class="{'sorting-panel__button--active': localValue === 'All'}"
                @click="onClick('All')"
            >
                {{ $t('o-sorting-panel_all') }}
            </button>
            <button
                type="button"
                class="sorting-panel__button"
                :class="{'sorting-panel__button--active': button.value === localValue}"
                v-for="(button, index) in showDefinedButtons"
                :key="index"
                @click="onClick(button.value)"
            >
                {{ button.name }}
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
    
import { characters } from "./o-sorting-panel-characters";

export default {
    name: "OSortingPanel",
    props: {
        label: {
            type: String,
            default: ''
        },
        /**
         * Value for v-model
         */
        value: {
            type: String,
            default: ''
        },
        /**
         * Show defined buttons
         */
        definedButtons: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        ...mapGetters([
            'getActiveLocale'
        ]),
        localValue: {
            get() {
                return this.value;
            },
            set(e) {
                this.$emit('input', e)
            }
        },
        getCharacters() {
            return characters[this.getActiveLocale];
        },
        showDefinedButtons() {
            if (this.definedButtons.length) {
                return this.getCharacters.filter(item => {
                    let find = '';
                    for (let i = 0; i < item.value.length; i++) {
                        if(this.definedButtons.includes(item.value.charAt(i)) === true) {
                            find = true;
                            break
                        }
                    }
                    return item = find
                })
            }
            return this.getCharacters;
        }
    },
    methods: {
        onClick(evt) {
            this.localValue = this.value === evt ? 'All' : evt;
            this.$emit('onClick', evt);
        }
    }
}

</script>

<style lang="scss">
@import "o-sorting-panel";
</style>
